import { getCurrentFeatureSlug } from '$/utils/index.js'
import { useFeatureStore } from '$/stores/feature.ts'
import { useNotify } from '$/composables/useNotify'

export function useSubmit() {
  const featureStore = useFeatureStore()
  const { pushError } = useNotify()

  const onSubmit = (onFinished) => {
    featureStore.previewStatuses = []

    const asyncTask = [
      'face-swap',
      'upscale-and-enhance-image',
      'restore-old-photo',
      'colorize-black-and-white-photo',
      'remove-background',
      'blur-background',
      'trim-transparent-pixels',
      'image-shadow-generator',
    ].includes(getCurrentFeatureSlug())
    const bulkTask = featureStore.feature.bulk_request_required && featureStore.images.length > 1
    featureStore.taskOptions.asyncTask = asyncTask
    featureStore.taskOptions.bulkTask = bulkTask

    // Allow full image for features which allow full image for free plan
    if (!featureStore.feature.full_image_request_required) featureStore.taskOptions.size = 'full'

    featureStore.processing = true
    if (!asyncTask && !bulkTask) featureStore.progressModal?.show()
    featureStore
      .execute(getCurrentFeatureSlug())
      .then(() => {
        if (!asyncTask && !bulkTask) onFinished()
      })
      .catch((err) => {
        console.error(err)
        pushError(err?.response?.data?.error)
        featureStore.processing = false
      })
      .finally(() => featureStore.progressModal?.hide())
  }

  return { onSubmit }
}
